import { RubricSection } from 'services/candidate/constants';

export enum Steps {
  JOB_DESCRIPTION = 'JOB_DESCRIPTION',
  CHOOSE_GROUP = 'CHOOSE_GROUP',
  NEW_RULESET = 'NEW_RULESET',
  RULESET_SUMMARY = 'RULESET_SUMMARY',
  REQUIREMENTS = 'REQUIREMENTS',
  UPLOAD = 'UPLOAD',
  AUTOMATION = 'AUTOMATION'
}

export enum CandidateFormFields {
  nonAtsJobDescription = 'nonAtsJobDescription',
  cvS3Keys = 'cvS3Keys',
  csvS3Key = 'csvS3Key',
  rubric = 'rubric',
  weights = 'weights',
  atsJobs = 'atsJobs',
  requirements = 'analysisRequirements',
  candidateBatchGroupId = 'candidateBatchGroupId',
  candidateBatchGroupName = 'candidateBatchGroupName',
  shouldCreateNewCandidateBatchGroup = 'shouldCreateNewCandidateBatchGroup',
  isSavingRulesetsForSingleJob = 'isSavingRulesetsForSingleJob',
  automationTasks = 'automationTasks',
  isCandidateBatchGroupOptional = 'isCandidateBatchGroupOptional'
}

export const STEPS_WITH_SKIP = [Steps.UPLOAD, Steps.AUTOMATION];

export { RubricSection };

export enum TabsValue {
  ROLES = 'roles',
  APPLICANTS = 'applicants',
  SOURCED_CANDIDATES = 'sourcedCandidates'
}

export const labelByValue = {
  [TabsValue.ROLES]: 'Analyses',
  [TabsValue.APPLICANTS]: 'Applicants',
  [TabsValue.SOURCED_CANDIDATES]: 'Invited'
};
